// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"93c9a355","457":"6bf90c09","709":"2ebcbbb2","720":"21747aff","787":"9415521c","859":"c4c2d305","914":"bfce91e9"}[chunkId] + ".chunk.js";
};